import { useEffect, useRef } from 'react'

export const usePreparePDF = () => {
  const styleRef = useRef<HTMLStyleElement | null>(null)

  useEffect(() => {
    if (!styleRef.current) {
      const style = document.createElement('style')

      styleRef.current = style

      style.innerHTML = `
        @media print {
          /* Hide UI elements not needed in print */
          button, .no-print, nav, footer, header {
            display: none !important;
          }

          /* Ensure color scales and colored elements print correctly */
          div[css], div[style], svg, .color-scale-element, [class*="heatmap"] {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* Ensure background colors are printed */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* Specific fix for NDVI scale elements */
          [class*="ndvi"] div,
          [id*="ndvi"] div,
          div[css] > div[key],
          div[css] > div[css] {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* Ensure page breaks don't occur in the middle of elements */
          .page-break-avoid {
            page-break-inside: avoid;
          }

          /* Force page break before element */
          .page-break-before {
            page-break-before: always;
          }

          /* Text inputs styling */
          .report-textarea, input[type="text"], textarea {
            border: none !important;
            resize: none !important;
            background-color: white !important;
            color: black !important;
            box-shadow: none !important;
            outline: none !important;
          }

          .report-textarea::placeholder,
          .report-textarea::-webkit-input-placeholder,
          .report-textarea::-moz-placeholder,
          .report-textarea:-ms-input-placeholder,
          .report-textarea:-moz-placeholder,
          .report-textarea[placeholder],
          input::placeholder,
          textarea::placeholder {
            color: transparent !important;
            opacity: 0 !important;
            visibility: hidden !important;
            display: none !important;
            content: "" !important;
          }

          /* Ensure good contrast and readability */
          body {
            color: black !important;
            background: white !important;
            font-size: 12pt;
            line-height: 1.5;
          }

          /* Links should show their URL in parentheses */
          a[href]:after {
            content: " (" attr(href) ")";
            font-size: 90%;
          }

          /* Ensure all content is visible */
          * {
            overflow: visible !important;
          }
        }
      `

      document.head.appendChild(style)
    }

    return () => {
      if (styleRef.current && document.head.contains(styleRef.current)) {
        document.head.removeChild(styleRef.current)

        styleRef.current = null
      }
    }
  }, [])

  const printDocument = (filename?: string) => {
    const originalTitle = document.title

    if (filename) {
      document.title = filename
    }

    window.print()

    // Change title so file name is populated
    document.title = originalTitle
  }

  return { printDocument }
}
